import React, { useState } from 'react';
import { Modal, Box, Typography, Button, IconButton, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchResultGrid from '../searchResultGrid/searchResultGrid';
import modalStyle from '../../styles/modalStyle';
import getCoverageColDef from '../../colDef/coverageColumnDef';
import Coverage from '../../interfaces/coverage';
import CoverageService from '../../services/coverageService';

interface BulkApproveCoverageModalProps {
    open: boolean;
    onClose: () => void;
    selectedRows: Coverage[];
    onSuccess: () => void;
}

const BulkApproveCoverageModal: React.FC<BulkApproveCoverageModalProps> = ({ open, onClose, selectedRows, onSuccess }) => {
    const [loading, setLoading] = useState<boolean>(false);

    const handleSubmit = async () => {
        try {
            setLoading(true);
            const promises = selectedRows.map(coverage => 
                CoverageService.updateCoverageStatus(coverage.id, {
                    status: "APPROVED"
                })
            );
            
            await Promise.all(promises);
            alert(`Successfully approved ${selectedRows.length} coverage${selectedRows.length > 1 ? 's' : ''}`);
            onClose();
            onSuccess();
        } catch (error) {
            console.error('Error approving coverage: ', error);
            alert("Failed to approve coverage");
        } finally {
            setLoading(false);
            onClose();
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                {loading ? (
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                        <CircularProgress size={50} />
                    </Box>
                ) : (
                    <>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="h6">Approve Coverage</Typography>
                            <IconButton onClick={onClose}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <Typography variant="body1" sx={{ mt: 2, mb: 3 }}>
                            Are you sure you want to approve {selectedRows.length} coverage{selectedRows.length > 1 ? 's' : ''}?
                        </Typography>
                        <Box mt={3}>
                            <Typography variant="subtitle1">Selected Rows:</Typography>
                            <SearchResultGrid
                                getRowId={(row: Coverage) => row.id}
                                results={selectedRows}
                                onSelectRow={() => {}}
                                columns={getCoverageColDef()}
                                isRowSelectionAllowed={false}
                            />
                        </Box>
                        <Box sx={{ mt: 3 }} display="flex" justifyContent="flex-end" gap={1}>
                            <Button variant="outlined" onClick={onClose}>
                                Cancel
                            </Button>
                            <Button variant="contained" color="success" onClick={handleSubmit}>
                                Confirm
                            </Button>
                        </Box>
                    </>
                )}
            </Box>
        </Modal>
    );
};

export default BulkApproveCoverageModal;
